import { compact, seriesColor } from "./util";

/**
 * 12–48 point inline trend. Single series, no axes, current period marked
 * with an 8px end dot (2px surface ring). Accessible summary via aria-label.
 */
export function Sparkline({ values, width = 96, height = 24, color, label, formatValue = compact }: { values: number[]; width?: number; height?: number; color?: string; label: string; formatValue?: (v: number) => string }) {
  const clean = values.map((v) => (Number.isFinite(v) ? v : 0));
  const n = clean.length;
  const max = Math.max(1, ...clean);
  const last = clean[n - 1] ?? 0;
  const first = clean[0] ?? 0;
  const c = color ?? seriesColor(0);
  const xAt = (i: number) => (n <= 1 ? width / 2 : 4 + (i / (n - 1)) * (width - 8));
  const yAt = (v: number) => 4 + (height - 8) - (v / max) * (height - 8);
  const d = clean.map((v, i) => `${i === 0 ? "M" : "L"}${xAt(i).toFixed(1)},${yAt(v).toFixed(1)}`).join("");
  const trend = last > first ? "up" : last < first ? "down" : "flat";
  return (
    <svg className="viz" width={width} height={height} viewBox={`0 0 ${width} ${height}`} role="img" aria-label={`${label}: ${n} points, latest ${formatValue(last)}, trend ${trend}`} style={{ display: "inline-block", verticalAlign: "middle" }}>
      {n === 0 ? (
        <line x1={4} x2={width - 4} y1={height / 2} y2={height / 2} className="viz-grid" />
      ) : (
        <>
          <path className="viz-line" stroke={c} d={d} />
          <circle className="viz-marker" fill={c} r={3.5} cx={xAt(n - 1)} cy={yAt(last)} />
        </>
      )}
    </svg>
  );
}
